import { NgModule } from '@angular/core';
import { InitialNavigation, RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { AuthGuardService, LoggedInUserService } from './shared/services/auth/auth.guard.service';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/module/login/login.module').then((m) => m.LoginModule),
    canActivate: [LoggedInUserService],
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: '',
    loadChildren: () => import('./pages/module/layout/layout.module').then((m) => m.LayoutModule),
    canActivate: [AuthGuardService],
  },
  // {
  //   path: '',
  //   loadChildren: () => import('./pages/module/home/home.module').then((m) => m.HomeModule),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: 'calibration',
  //   loadChildren: () => import('./pages/module/calibration/calibration.module').then((m) => m.CalibrationModule),
  //   canActivate: [AuthGuardService],
  // },
  // {
  //   path: 'users',
  //   loadChildren: () => import('./pages/module/user/user.module').then((m) => m.UserModule),
  //   canActivate: [AuthGuardService],
  // },
  {
    path: '**',
    redirectTo: '/404',
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled' as InitialNavigation,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
